import { useEffect } from 'react';
import csEvent from '../utils/csEvent';
import { isWebAuthnSupported, events, logs } from '../utils/webAuthn';

const WebAuthnEligibility = ({
  acsTransId,
  token,
  gravityAuthnUrl,
  logger,
  updateDataHeader,
  dataHeader,
}) => {
  useEffect(() => {
    const requiredProps = acsTransId && token && gravityAuthnUrl;
    const baseEvent = { acsTransId, token, gravityAuthnUrl };
    if (requiredProps) {
      if (isWebAuthnSupported()) {
        csEvent({
          ...baseEvent, payload: events.webAuthnSupported, updateDataHeader, dataHeader,
        });
        window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable()
          .then((available) => {
            if (available) {
              csEvent({
                ...baseEvent, payload: events.platformAuthnAvailable, updateDataHeader, dataHeader,
              });
            } else {
              csEvent({
                ...baseEvent,
                payload: events.platformAuthnNotAvailable,
                updateDataHeader,
                dataHeader,
              });
            }
          })
          .catch((error) => {
            logger({ name: logs.publicKeyCredentialError, acsTransId }, error);
          });
      } else {
        csEvent({
          ...baseEvent, payload: events.webAuthnNotSupported, updateDataHeader, dataHeader,
        });
      }
    }
  }, [acsTransId, token, gravityAuthnUrl]);
  return null;
};

export default WebAuthnEligibility;
